module.exports = __webpack_public_path__ + "static/media/update-arrows.520d5f52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/update-arrows.svg
// module id = 227
// module chunks = 0